import React from 'react'
import {
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography
} from '@material-ui/core'

const fmt = (v) => {
  if (!v || v === 0) return ''
  return v.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
}

const headerStyle = {
  fontWeight: 700,
  fontSize: '0.85rem',
  backgroundColor: '#263238',
  color: '#fff',
  borderRight: '1px solid #455a64',
  padding: '10px 12px'
}

const cellStyle = {
  fontSize: '0.85rem',
  borderRight: '1px solid #e0e0e0',
  borderBottom: '1px solid #e0e0e0',
  padding: '8px 12px'
}

const footerStyle = {
  fontWeight: 700,
  fontSize: '0.85rem',
  borderRight: '1px solid #e0e0e0',
  borderBottom: '1px solid #e0e0e0',
  padding: '10px 12px',
  backgroundColor: '#f5f5f5'
}

const coverageDot = (status) => {
  let color = '#9e9e9e'
  if (status === 'covered') color = '#4caf50'
  else if (status === 'partial') color = '#ff9800'
  else if (status === 'missing') color = '#f44336'
  else if (status === 'needs_review') color = '#2196f3'
  return (
    <span
      style={{
        display: 'inline-block',
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: color,
        marginRight: 6,
        verticalAlign: 'middle'
      }}
    />
  )
}

const OutputTable = ({ data }) => {
  if (!data || !data.items) {
    return (
      <Paper style={{ padding: 20, textAlign: 'center' }}>
        <Typography variant="body2" color="textSecondary">
          Select a building to view output.
        </Typography>
      </Paper>
    )
  }

  return (
    <Paper style={{ overflowX: 'auto' }}>
      <Table style={{ borderCollapse: 'collapse', minWidth: 800 }}>
        <TableHead>
          <TableRow>
            <TableCell style={{ ...headerStyle, width: 80 }}>ITEM NO.</TableCell>
            <TableCell style={{ ...headerStyle, minWidth: 250 }}>ITEM DESCRIPTION</TableCell>
            <TableCell style={{ ...headerStyle, width: 70 }}>UNIT</TableCell>
            <TableCell style={{ ...headerStyle, width: 90 }} align="right">QUANTITY</TableCell>
            <TableCell style={{ ...headerStyle, width: 110 }} align="right">UNIT COST</TableCell>
            <TableCell style={{ ...headerStyle, width: 120, borderRight: 'none' }} align="right">TOTAL COST</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.items.map((item, idx) => (
            <TableRow key={item.itemNo || idx} hover>
              <TableCell style={cellStyle}>
                {coverageDot(item.coverageStatus)}
                {item.itemNo || ''}
              </TableCell>
              <TableCell style={cellStyle}>{item.description || ''}</TableCell>
              <TableCell style={cellStyle}>{item.unit || ''}</TableCell>
              <TableCell style={cellStyle} align="right">
                {item.quantity ? item.quantity.toLocaleString() : ''}
              </TableCell>
              <TableCell style={cellStyle} align="right">{fmt(item.unitCost)}</TableCell>
              <TableCell style={{ ...cellStyle, borderRight: 'none' }} align="right">{fmt(item.totalCost)}</TableCell>
            </TableRow>
          ))}
          {/* Subtotal */}
          <TableRow>
            <TableCell style={footerStyle} colSpan={5} align="right">SUBTOTAL</TableCell>
            <TableCell style={{ ...footerStyle, borderRight: 'none' }} align="right">
              {fmt(data.subtotal)}
            </TableCell>
          </TableRow>
          {/* Tax */}
          <TableRow>
            <TableCell style={footerStyle} colSpan={5} align="right">TAX</TableCell>
            <TableCell style={{ ...footerStyle, borderRight: 'none' }} align="right">
              {fmt(data.tax)}
            </TableCell>
          </TableRow>
          {/* Total */}
          <TableRow>
            <TableCell style={{ ...footerStyle, fontSize: '0.95rem', backgroundColor: '#e8eaf6' }} colSpan={5} align="right">
              TOTAL
            </TableCell>
            <TableCell
              style={{ ...footerStyle, fontSize: '0.95rem', borderRight: 'none', backgroundColor: '#e8eaf6' }}
              align="right"
            >
              {fmt(data.total)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  )
}

export default OutputTable
